import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { workspacePathFromOnboardingRoles } from '../../lib/onboarding/workspaceRoute.js'

const API = import.meta.env.VITE_API_URL || ''

function pathForState(state, roles = []) {
  if (state === 'sports') return '/onboarding/sports'
  if (state === 'organization') return '/onboarding/organization'
  if (state === 'consent') return '/onboarding/consent'
  if (state === 'ready') return workspacePathFromOnboardingRoles(roles)
  return '/onboarding'
}

export default function OnboardingTransitionRouter() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    function handleUpdate(event) {
      const state = event.detail?.onboarding?.state_key
      if (!state) return
      const nextPath = pathForState(state, event.detail?.roles ?? [])
      if (nextPath !== location.pathname) navigate(nextPath, { replace: true })
    }

    globalThis.addEventListener?.('argus:onboarding-updated', handleUpdate)
    return () => globalThis.removeEventListener?.('argus:onboarding-updated', handleUpdate)
  }, [location.pathname, navigate])

  useEffect(() => {
    if (location.pathname !== '/onboarding') return undefined

    let cancelled = false
    const fetchImpl =
      typeof globalThis.fetch === 'function' ? globalThis.fetch.bind(globalThis) : null
    if (!fetchImpl) return undefined

    fetchImpl(`${API}/api/onboarding`, { credentials: 'include' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (cancelled || !data?.onboarding?.state_key) return
        const nextPath = pathForState(data.onboarding.state_key, data.roles ?? [])
        if (nextPath !== location.pathname) navigate(nextPath, { replace: true })
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [location.pathname, navigate])

  return null
}
